import { getMe } from '@xstudios/xapp-auth/services/meService'
import { defineStore } from 'pinia'

function state() {
  return {
    error: null,
    loading: false,
    profile: null,
  }
}

const actions = {
  clear() {
    this.profile = null
    this.error = null
  },
  async fetch() {
    this.loading = true
    this.error = null
    try {
      const data = await getMe()
      this.profile = data
      return data
    } catch (error) {
      this.profile = null
      this.error = error?.response?.data?.detail || 'Failed to load profile'
      throw error
    } finally {
      this.loading = false
    }
  },
}

export const useMeStore = defineStore('me', {
  actions,
  state,
})
